<template>
  <v-dialog :value="value" width="1000px" @input.self="$emit('input', $event)">
    <v-card class="import-clients">
      <v-card-title> Importados da lista </v-card-title>
      <v-card-text>
        <v-container fluid class="pa-0 mb-5">
          <v-row>
            <v-col cols="5">
              <p class="text">Primeiramente selecione o arquivo .csv em seu computador.</p>

              <v-container fluid class="pa-0 import-file-block">
                <v-row>
                  <v-col class="import-col" @click="activateInput">
                    <mf-icon fill color="verde-l20">cloud_upload</mf-icon>
                    <span class="ml-2 text import">{{ fileName ? fileName : 'Importar lista de clientes' }}</span>
                    <p class="text import-hint mb-0">Somente formato .csv</p>

                    <input ref="file-input" class="hidden-input" type="file" @input="readFile($event)" />
                  </v-col>
                </v-row>
              </v-container>

              <p class="text">Em seguida, selecione a coluna desejada ao lado e nos diga em qual categoria ela se encaixa.</p>

              <div class="category-box">
                <span class="select-label" :class="[!contentSample.length ? 'disabled-opacity' : '']">Categorias</span>
                <v-select
                  v-model="selectedField"
                  :class="[!contentSample.length ? 'disabled-opacity' : '']"
                  :disabled="!contentSample.length"
                  :items="[
                    { value: 'ID', text: 'ID' },
                    { value: 'CPF_CNPJ', text: 'CPF/CNPJ' },
                  ]"
                  label="Selecione..."
                  solo
                />
              </div>
            </v-col>
            <v-col cols="7" class="preview-col pa-0" align="center" justify="center">
              <v-container class="pa-0" fill-height>
                <v-row justify="center">
                  <v-simple-table v-if="contentSample.length">
                    <tbody>
                      <tr v-for="(column, columnIndex) in contentSample" :key="columnIndex">
                        <td
                          v-for="(line, lineIndex) in column"
                          :key="lineIndex"
                          :class="[isColumnSelected(lineIndex) ? 'selected-column' : '']"
                          @click="setSelectedC(lineIndex)"
                        >
                          {{ line }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <span v-else>Aguardando arquivo em .csv</span>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
        <mf-action-buttons
          :primary-button="{
            text: 'Importar',
            action: finish,
            isVisible: true,
            isDisabled: disableFinishButton,
            isLoading: isLoading,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: closeDialog,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { MUTATION_CHECK_AND_UPLOAD_USERS_FROM_FILE } from '@/graphql'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fileName: '',
    fileType: '',
    fileContent: {},
    file: '',
    isLoading: false,
    contentSample: [],
    selectedColumn: null,
    selectedField: null,
  }),
  computed: {
    disableFinishButton() {
      if (this.selectedColumn === null || !this.selectedField) return true
      return false
    },
  },
  methods: {
    activateInput() {
      this.$refs['file-input'].click()
    },
    isColumnSelected(column) {
      return Boolean(column === this.selectedColumn)
    },
    readFile(event) {
      if (event.target.files.length === 0) return
      this.resetInputs()

      const file = event.target.files[0]
      this.file = file

      this.fileName = file.name
      this.fileType = file.type

      let reader = new FileReader()
      reader.onload = () => {
        this.fileContent = reader.result
        this.contentSample = this.fileContent
          .split('\n')
          .slice(0, 6)
          .map((row) => row.trim().split(';'))
      }

      reader.readAsText(file)
    },
    resetInputs() {
      this.selectedColumn = null
      this.selectedField = null
    },
    setSelectedC(index) {
      this.selectedColumn = index
    },
    closeDialog() {
      this.$emit('input', false)
    },
    async finish() {
      this.isLoading = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_CHECK_AND_UPLOAD_USERS_FROM_FILE,
          variables: {
            input: {
              file: this.file,
              identifierField: this.selectedField,
              fileColumnIndex: this.selectedColumn,
            },
          },
          context: {
            uri: this.$microservicesUrls['upload'],
          },
        })
        .then(({ data: { checkAndUploadUsersFromFile } }) => {
          this.$emit('objectSelected', { response: checkAndUploadUsersFromFile, selectedField: this.selectedField, fileName: this.fileName })
        })
        .catch((error) => {
          console.error(error)
        })
      this.isLoading = false
      this.closeDialog()
    },
  },
}
</script>

<style lang="scss">
.import-clients {
  .import-col {
    cursor: pointer;
    user-select: none;
  }
  .hidden-input {
    display: none;
  }
  .text {
    opacity: 0.87;
    max-width: 300px;
    &.import {
      color: $verde-l20;
    }
    &.import-hint {
      font-size: 12px;
      opacity: 0.54;
    }
  }
  .category-box {
    .select-label {
      opacity: 0.87;
    }
    .disabled-opacity {
      opacity: 0.54;
    }
  }
  .preview-col {
    background-color: $cinza-l90;
    border-radius: 4px;
    border: 1px solid $cinza-l10;
  }

  .v-data-table {
    max-width: 560px;
    user-select: none;
    tr {
      &:first-of-type {
        .selected-column {
          border-top: 1px solid $marca-0-l40;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        }
      }
      &:last-of-type {
        .selected-column {
          border-bottom: 1px solid $marca-0-l40;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }
    .selected-column {
      border-left: 1px solid $marca-0-l40;
      border-right: 1px solid $marca-0-l40;
      background-color: $marca-0-l90;
    }
    td {
      border: 1px solid transparent;
    }
    tr {
      cursor: pointer;
      &:hover {
        background-color: $branco !important;
      }
    }
  }
}
</style>
